import './Contact.css'

export default function Contact({ onBookCall }) {
  const handleEmail = () => {
    window.location.href = 'mailto:hello@northcortex.co.uk?subject=Enquiry from website'
  }

  return (
    <section className="contact section--navy" id="contact">
      <div className="container contact__inner">
        <div className="contact__bg-glow" aria-hidden="true" />

        <div className="contact__content">
          <span className="section-eyebrow contact__eyebrow">Get Started</span>
          <h2 className="section-heading section-heading--light contact__heading">
            Ready to move from AI curiosity<br className="contact__br" /> to AI in production?
          </h2>
          <p className="contact__subtext">
            Book a free 30-minute discovery call. No pitch deck, no pressure — just an honest
            conversation about where AI agents can deliver real value in your business.
          </p>

          <div className="contact__actions">
            <button className="btn btn--primary btn--primary-lg" onClick={onBookCall}>
              Book a Discovery Call
            </button>
            <button className="btn btn--outline-white" onClick={handleEmail}>
              Send a Message
            </button>
          </div>

          <p className="contact__reassurance">
            <LockIcon />
            No obligation. No spam. We respond within one business day.
          </p>
        </div>
      </div>
    </section>
  )
}

function LockIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
      <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
    </svg>
  )
}
